import React, { Fragment } from 'react';
import './Footer.css';

export const Footer = props => (
  <Fragment>
    <div className='footer'>
      {props.isConfirmation && (
        <p className='p1'>
            *Bitte beachte, dass die Bearbeitung deiner Anfrage bis zu 48
            Stunden dauern kann.
        </p>
      )}
      <div className='wrapper pad'>
        <div className='footer-meta'>
          <a
            href='https://www.mcdonalds.de/de/kontakt/?mcdelivery=1'
            className='link-small'
          >
            <span className='borderBottomHover'>Kontakt</span>
          </a>
          <a href='http://www.mcdonalds.de/datenschutz' className='link-small'>
            <span className='borderBottomHover'>Datenschutz</span>
          </a>
          <a href='http://www.mcdonalds.de/impressum' className='link-small'>
            <span className='borderBottomHover'>Impressum</span>
          </a>
        </div>
        <div className='bg_big display-tablet display-mobile'>
          <img
            className='bg_big_img'
            src='http://wpm.ccmp.eu/wpm/409/Images_2019_neu/Footer_Background_.jpg'
            alt=''
          />
        </div>
        <div className='footerLogo'>
          <img
            className='footerLogoImg'
            alt='McDonald´s'
            src='http://wpm.ccmp.eu/wpm/409/Images_2019_neu/mcdonalds-logo.png'
          />
        </div>
        <div className='bg_big display-desktop'>
          <img
            className='bg_big_img'
            src='http://wpm.ccmp.eu/wpm/409/Images_2019_neu/Footer_Background_.jpg'
            alt=''
          />
        </div>
        <div className='cr'>
          <p className='crCopy'>&copy; {new Date().getFullYear()} McDonald&apos;s</p>
        </div>
      </div>
    </div>
  </Fragment>
);
